import { Boxes, FolderKanban, Layers3, Palette, Shirt } from "lucide-react";

import MetricCard from "@/components/layout/MetricCard";
import type { RenderMeta } from "@/lib/api-types";

export default function RenderCatalogSummaryCards({
  meta,
}: {
  meta: RenderMeta;
}) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
      <MetricCard
        label="Source assets"
        value={meta.summary.sourceAssetCount.toLocaleString()}
        hint={`${meta.summary.pedModelCount.toLocaleString()} ped models được parse vào catalog.`}
        icon={<Boxes className="h-4 w-4" />}
      />
      <MetricCard
        label="Mesh parts"
        value={meta.summary.meshPartCount.toLocaleString()}
        hint="Đơn vị render nhỏ nhất đang duyệt trong asset library."
        icon={<Layers3 className="h-4 w-4" />}
      />
      <MetricCard
        label="Drawables"
        value={meta.summary.drawableCount.toLocaleString()}
        hint="Drawable buckets sau khi gom theo slot và collection."
        icon={<Shirt className="h-4 w-4" />}
      />
      <MetricCard
        label="Texture variants"
        value={meta.summary.textureVariantCount.toLocaleString()}
        hint="Biến thể texture hiện có thể preview hoặc gắn pricing."
        icon={<Palette className="h-4 w-4" />}
      />
      <MetricCard
        label="Collections"
        value={meta.summary.collectionCount.toLocaleString()}
        hint="Danh sách collection đang được hiển thị trong filter."
        icon={<FolderKanban className="h-4 w-4" />}
      />
    </div>
  );
}
